import { Howl } from 'howler';

// Create sound instances
const successSound = new Howl({
  src: ['/sounds/success.mp3'],
  volume: 0.5
});

const errorSound = new Howl({
  src: ['/sounds/alert.mp3'],
  volume: 0.5
});

const warningSound = new Howl({
  src: ['/sounds/warning.mp3'],
  volume: 0.5
});

// Function to play success sound
export const playSuccessSound = () => {
  successSound.play();
};

// Function to play error sound
export const playErrorSound = () => {
  errorSound.play();
};

// Function to play warning sound
export const playWarningSound = () => {
  warningSound.play();
}; 